
export default {
    name: "cookieControl"
}
